import React, { useState, useContext } from 'react';
import {
    PaymentElement,
    useStripe,
    useElements
} from '@stripe/react-stripe-js';
import './CheckoutForm.css';

import { LanguageContext } from '../context/LanguageContext';
import commonTranslations from '../languages/common.json';

export default function CheckoutForm() {
    const stripe = useStripe();
    const elements = useElements();
    const { lang } = useContext(LanguageContext);
    const t = commonTranslations[lang].common.checkoutForm;
    const [message, setMessage] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;

        setIsProcessing(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: window.location.origin + '/iot/administration/payment?status=success',
            },
        });

        if (error) {
            setMessage(error.message || t.errorUnexpected);
        }

        setIsProcessing(false);
    };

    return (
        <form className="checkout-form" onSubmit={handleSubmit}>
            <PaymentElement className="payment-element" />
            <button
                className="stripe-button"
                type="submit"
                disabled={isProcessing || !stripe}
            >
                {isProcessing ? t.processing : t.completePayment}
            </button>
            {message && <div className="message">{message}</div>}
        </form>
    );
}
